import styled from 'styled-components';

interface containerProps {
  containerPosition?: string;
}
export const DropdownContainer = styled.div<containerProps>`
  position: ${({ containerPosition }) => containerPosition || 'relative'};
  display: flex;
  gap: 0.313rem;
  align-items: center;
`;

export const PopupContainer = styled.div<{
  top?: string;
  left?: string;
  overflow?: string;
  width?: string;
  height?: string;
}>`
  position: absolute;
  top: ${({ top }) => top || '100%'};
  width: ${({ width }) => width || 'max-content'};
  max-height: ${({ height }) => height || 'max-content'};
  z-index: 99;
  right: 0;
  background-color: white;
  border-radius: 0.5rem;
  padding-bottom: 0.5rem;
  overflow: ${({ overflow }) => overflow || 'hidden'};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
`;
export const List = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  padding: 0;
  margin: 0;
`;
export const RedirectToDocCenter = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primaryBlue5};
`;
export const OptionItemContainer = styled.div<{ height?: string }>`
  display: flex;
  align-items: center;
  height: ${({ height }) => height || ''};
  width: auto;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey10};
  }
`;

export const StyledSearch = styled.div`
  padding: 0.6rem 0;
  display: flex;
  flex-direction: column;
  input {
    margin: 0.5rem 0.5rem 0.125rem;
  }
`;

export const SearchBarWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 1.25rem;
  left: 1.25rem;
  cursor: auto;
`;
export const OptionItem = styled.div<{ width?: string; padding?: string }>`
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding || '1rem'};
  cursor: pointer;
  position: relative;
  max-width: 15rem;
  width: fit-content;
  overflow: visible;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey10};
  }
  &:hover ul {
    display: block;
  }
`;
export const SelectedOption = styled.div`
  width: 4rem;
`;
export const SubmenuContainer = styled.ul<{ width?: string }>`
  width: ${({ width }) => width};
  padding: 0;
  margin: 0;
  list-style: none;
  position: absolute;
  left: 100%;
  top: 0;
  width: max-content;
  z-index: 9999;
  right: 0;
  background-color: white;
  border: 1px;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
  display: none;
`;
export const Label = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
`;

export const FilterHeading = styled.div`
  padding: 0.75rem;
  background: ${({ theme }) => theme.colors.lightGrey10};
`;
